import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Box, Text, Center, Table, Tbody, Tr, Td, Badge, Tooltip, Flex, Th } from '@chakra-ui/react';
import c from '../../../constant';
import '../../../containers/CompanySubmissionReport/style.css';
import moment from 'moment';
import { SectionHeader } from '../../Other';
export default function ComplaintOnInsurancePrint({ data, ...props }) {
	const { t } = useTranslation();

	function handleRepresentativeName(complaint) {
		if (complaint?.representative === 'yes') {
			return complaint?.plaintiffOrRepresentativeName;
		} else if (complaint?.representative === 'no') {
			if (complaint?.plaintiff === 'REAL_PERSON') {
				return complaint?.name;
			} else if (complaint?.plaintiff === 'LEGAL_ENTITY') {
				return complaint?.companyName;
			}
		} else {
			if (complaint?.plaintiffOrRepresentativeName) {
				return complaint?.plaintiffOrRepresentativeName;
			} else if (complaint?.plaintiff === 'REAL_PERSON') {
				return complaint?.name;
			} else if (complaint?.plaintiff === 'LEGAL_ENTITY') {
				return complaint?.companyName;
			}
		}
	}

	function getPlatformbadge(platform) {
		switch (platform) {
			case 'mobile':
				return (
					<Badge ml={1} colorScheme="blue">
						{t('Mobile')}
					</Badge>
				);
			case 'web':
				return (
					<Badge ml={1} colorScheme="purple">
						{t('Website')}
					</Badge>
				);
			default:
				return (
					<>
						<Badge ml={1} colorScheme="purple">
							{t('Website')}
						</Badge>
					</>
				);
		}
	}

	function getStatus({ settled, settledDate }, adminComplaintStatus) {
		if (settled === true) {
			return (
				<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
					<Badge colorScheme="green">{t('Settled')}</Badge>
				</Tooltip>
			);
		} else {
			switch (adminComplaintStatus) {
				case 'IN_PROGRESS':
					return <Badge colorScheme="red">{t('In progress')}</Badge>;
				case 'WAITING_FOR_COMPANY_REPLY':
					return <Badge colorScheme="yellow">{t('Waiting for company reply')}</Badge>;
				case 'RECIEVED_COMPANY_REPLY':
					return <Badge colorScheme="teal">{t('Received company reply')}</Badge>;
				case 'PROVIDED_REPLY_LETTER_TO_APPLICANT':
					return <Badge colorScheme="purple">{t('Provided reply letter to applicant')}</Badge>;
				case 'APPLICANT_MADE_DECISION':
					return <Badge colorScheme="blue">{t('Applicant made decision')}</Badge>;
				case 'SETTLED':
					return (
						<Tooltip label={settledDate ? moment(settledDate).format('LLLL') : ''}>
							<Badge colorScheme="green">{t('Settled')}</Badge>
						</Tooltip>
					);
				case 'WITHDRAWN':
					return <Badge colorScheme="gray">{t('Withdrawn')}</Badge>;
				default:
					return '-';
			}
		}
	}

	return (
		<>
			<Flex className="show-only-printing" {...props}>
				<Box width="100%">
					<Center>
						<Box
							w="100%"
							bg="white"
							borderRadius={c.borderRadius}
							border="1px solid #dbdbdb"
							boxShadow="0 1px 2px rgba(var(--black, #000), 0.1)"
							pb={4}
						>
							<Flex
								h="48px"
								p={4}
								pt={0}
								pb={0}
								mb={4}
								bg="#FAFAFA"
								alignItems="center"
								justifyContent="space-between"
								borderBottom="1px solid #dbdbdb"
							>
								<SectionHeader title={t('Complaint on Insurance')} fontSize="lg" />
							</Flex>
							<Box p="16px">
								<Table variant="simple" className="table-company-proposal-list">
									<Tbody>
										<Tr className="td-as-th">
											<Th>{t('Number')}</Th>
											<Th>{t('Subject')}</Th>
											<Th>{t('Created At')}</Th>
											<Th>{t('Plaintiff/Representative Name')}</Th>
											<Th>{t('Platform')}</Th>
											<Th isNumeric>{t('Status')}</Th>
										</Tr>
										{data?.getComplaintsOnInsurance?.complaints.length <= 0 && (
											<Tr>
												<Td>
													<Text>{t('No Data')}</Text>
												</Td>
											</Tr>
										)}
										{data?.getComplaintsOnInsurance?.complaints?.map((complaint, index) => {
											return (
												<Tr cursor="pointer" _hover={{ bg: 'gray.200' }} key={`complaint-${index}`} bg="white">
													<Td>{complaint.no}</Td>
													<Td fontWeight="500">
														<Text maxW="400px" noOfLines={4}>
															{complaint.subject}
														</Text>
													</Td>
													<Td>{moment(complaint.createdAt).format('LLLL')}</Td>
													<Td>{handleRepresentativeName(complaint)}</Td>
													<Td>{getPlatformbadge(complaint?.platform)}</Td>
													<Td isNumeric>
														{complaint.spam === false &&
															getStatus(
																{ settled: complaint.settled, settledDate: complaint.settledDate },
																complaint.adminComplaintStatus,
															)}
														{complaint.spam === true && <Badge colorScheme="red">{t('Spam')}</Badge>}
													</Td>
												</Tr>
											);
										})}
									</Tbody>
								</Table>
								<Box justifyContent="flex-end">
									<Text ml="2" mt="4">
										{t('Total Rows')}: <b>{data?.getComplaintsOnInsurance?.totalRows}</b>
									</Text>
								</Box>
							</Box>
						</Box>
					</Center>
				</Box>
			</Flex>
		</>
	);
}
